/**
 * SignalR Hub Endpoints
 */
export const SIGNALR_HUBS = {
  MASTER: "/master-hub",
} as const;

/**
 * SignalR Event Names
 */
export const SIGNALR_EVENTS = {
  // Master hub events
  SAMPLE_BARCODE: "sample-barcode",
  SAMPLE_RESULTS: "sample-results",
} as const;

/**
 * SignalR Event Types
 */
export interface SampleBarcodeChanged {
  oldBarcode: string;
  newBarcode: string;
}

export interface TestEntry {
  id: string;
  testCode: string;
  result: string;
}

export interface SampleResultEvent {
  sampleId: string;
  addedResults?: TestEntry[];
  deletedResults?: TestEntry[];
  modifiedResults?: TestEntry[];
}

export type SignalRHubName = keyof typeof SIGNALR_HUBS;
export type SignalREventName = (typeof SIGNALR_EVENTS)[keyof typeof SIGNALR_EVENTS];
